/* This file was automatically generated on 1666691919.885 */

/* eslint-disable global-require */

module.exports = {
  ArrayTypeName: require('./ArrayTypeName'),
  AssemblyAssignment: require('./AssemblyAssignment'),
  AssemblyBlock: require('./AssemblyBlock'),
  AssemblyCall: require('./AssemblyCall'),
  AssemblyCase: require('./AssemblyCase'),
  AssemblyFor: require('./AssemblyFor'),
  AssemblyFunctionDefinition: require('./AssemblyFunctionDefinition'),
  AssemblyIf: require('./AssemblyIf'),
  AssemblyLocalDefinition: require('./AssemblyLocalDefinition'),
  AssemblyMemberAccess: require('./AssemblyMemberAccess'),
  AssemblyStackAssignment: require('./AssemblyStackAssignment'),
  AssemblySwitch: require('./AssemblySwitch'),
  BinaryOperation: require('./BinaryOperation'),
  Block: require('./Block'),
  BooleanLiteral: require('./BooleanLiteral'),
  Break: require('./Break'),
  BreakStatement: require('./BreakStatement'),
  CatchClause: require('./CatchClause'),
  Conditional: require('./Conditional'),
  Continue: require('./Continue'),
  ContinueStatement: require('./ContinueStatement'),
  ContractDefinition: require('./ContractDefinition'),
  CustomErrorDefinition: require('./CustomErrorDefinition'),
  DecimalNumber: require('./DecimalNumber'),
  DoWhileStatement: require('./DoWhileStatement'),
  ElementaryTypeName: require('./ElementaryTypeName'),
  EmitStatement: require('./EmitStatement'),
  EnumDefinition: require('./EnumDefinition'),
  EnumValue: require('./EnumValue'),
  EventDefinition: require('./EventDefinition'),
  ExpressionNameValue: require('./ExpressionNameValue'),
  ExpressionStatement: require('./ExpressionStatement'),
  FileLevelConstant: require('./FileLevelConstant'),
  ForStatement: require('./ForStatement'),
  ForRangeStatement: require('./ForRangeStatement'),
  FunctionCall: require('./FunctionCall'),
  FunctionDefinition: require('./FunctionDefinition'),
  FunctionTypeName: require('./FunctionTypeName'),
  HexLiteral: require('./HexLiteral'),
  HexNumber: require('./HexNumber'),
  Identifier: require('./Identifier'),
  IfStatement: require('./IfStatement'),
  ImportDirective: require('./ImportDirective'),
  IndexAccess: require('./IndexAccess'),
  IndexRangeAccess: require('./IndexRangeAccess'),
  InheritanceSpecifier: require('./InheritanceSpecifier'),
  InlineAssemblyStatement: require('./InlineAssemblyStatement'),
  LabelDefinition: require('./LabelDefinition'),
  Mapping: require('./Mapping'),
  MemberAccess: require('./MemberAccess'),
  ModifierDefinition: require('./ModifierDefinition'),
  ModifierInvocation: require('./ModifierInvocation'),
  NameValueExpression: require('./NameValueExpression'),
  NameValueList: require('./NameValueList'),
  NameValueBlockStatement: require('./NameValueBlockStatement'),
  NewExpression: require('./NewExpression'),
  NumberLiteral: require('./NumberLiteral'),
  OptionalTypeName: require('./OptionalTypeName'),
  PragmaDirective: require('./PragmaDirective'),
  RepeatStatement: require('./RepeatStatement'),
  ReturnStatement: require('./ReturnStatement'),
  RevertStatement: require('./RevertStatement'),
  SourceUnit: require('./SourceUnit'),
  StateVariableDeclaration: require('./StateVariableDeclaration'),
  StringLiteral: require('./StringLiteral'),
  StructDefinition: require('./StructDefinition'),
  ThrowStatement: require('./ThrowStatement'),
  TryStatement: require('./TryStatement'),
  TupleExpression: require('./TupleExpression'),
  TypeDefinition: require('./TypeDefinition'),
  TypeNameExpression: require('./TypeNameExpression'),
  UnaryOperation: require('./UnaryOperation'),
  UncheckedStatement: require('./UncheckedStatement'),
  UserDefinedTypeName: require('./UserDefinedTypeName'),
  UsingForDeclaration: require('./UsingForDeclaration'),
  VariableDeclaration: require('./VariableDeclaration'),
  VariableDeclarationStatement: require('./VariableDeclarationStatement'),
  VectorTypeName: require('./VectorTypeName'),
  WhileStatement: require('./WhileStatement')
};
